import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    registrationLoading: false,
    registrationResponse: null,
    inviteVerificationResponse: null,
    emailAvailability: null,
    usernameAvailability: null
  },
  getters: {
    REG_LOADING: state => state.registrationLoading,
    REG_RESPONSE: state => state.registrationResponse,
    INVITE_VERIFICATION_RESPONSE: state => state.inviteVerificationResponse,
    EMAIL_AVAILABILITY_RESPONSE: state => state.emailAvailability,
    USERNAME_AVAILABILITY_RESPONSE: state => state.usernameAvailability
  },
  mutations: {
    SET_REG_LOADING: (state, payload) => {
      state.registrationLoading = payload
    },
    SET_REG_RESPONSE: (state, payload) => {
      state.registrationResponse = payload
    },
    SET_INVITE_VERIFICATION_RESPONSE: (state, payload) => {
      state.inviteVerificationResponse = payload
    },
    SET_EMAIL_AVAILABILITY_RESPONSE: (state, payload) => {
      state.emailAvailability = payload
    },
    SET_USERNAME_AVAILABILITY_RESPONSE: (state, payload) => {
      state.usernameAvailability = payload
    }
  },
  actions: {
    SAVE_USER: async (context, payload) => {
      context.commit('SET_REG_LOADING', true)
      
      try {
        const response = await Axios.post(`/user`, payload.data, payload.config)
        context.commit('SET_REG_RESPONSE', response.data)
      } catch (error) {
        context.commit('SET_REG_RESPONSE', error.response.data)
      } finally {
        context.commit('SET_REG_LOADING', false)
      }
    },
    VERIFY_INVITE: async (context, payload) => {
      try {
        const response = await Axios.post('/user/verify-invite', payload)
        context.commit('SET_INVITE_VERIFICATION_RESPONSE', response.data)
      } catch (error) {
        context.commit('SET_INVITE_VERIFICATION_RESPONSE', error.response.data)
      }
    },
    CHECK_EMAIL_AVAILABILITY: async (context, payload) => {
      try {
        const response = await Axios.post('/user/check-email', payload)
        context.commit('SET_EMAIL_AVAILABILITY_RESPONSE', response.data)
      } catch (error) {
        context.commit('SET_EMAIL_AVAILABILITY_RESPONSE', error.response.data)
      }
    },

    CHECK_USERNAME_AVAILABILITY: async (context, payload) => {
      try {
        const response = await Axios.post('/user/check-username', payload)
        context.commit('SET_USERNAME_AVAILABILITY_RESPONSE', response.data)
      } catch (error) {
        context.commit(
          'SET_USERNAME_AVAILABILITY_RESPONSE',
          error.response.data
        )
      }
    }
  }
}
